export default "<img [src]=\"imgURL\" class=\"img-responsive\">";